module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_gov.509850a188f45add184a9b9586213acb.svg";